import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

const avatar = tv({
  base: `
    flex shrink-0 grow-0 items-center justify-center rounded-full bg-background
  `,
  slots: {
    fallback: "font-medium text-text-primary",
    image: "size-full object-cover text-[0px]",
  },
  variants: {
    size: {
      "3xs": { base: "size-4", fallback: "text-xs" },
      "2xs": { base: "size-6", fallback: "text-xs" },
      xs: { base: "size-8", fallback: "text-xs" },
      sm: { base: "size-14", fallback: "text-base" },
      md: { base: "size-18", fallback: "text-xl" },
      lg: { base: "size-24", fallback: "text-2xl" },
      xl: { base: "size-32", fallback: "text-3xl" },
    },
    square: {
      true: {
        base: "rounded-md",
        image: "rounded-md",
      },
    },
    circle: {
      true: {
        base: "rounded-full",
        image: "rounded-full",
      },
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export default function Avatar({
  src,
  alt,
  name,
  size,
  square,
  circle,
  className,
}: {
  readonly src: string | undefined | null;
  readonly alt: string;
  readonly name?: string;
  readonly className?: string;
} & VariantProps<typeof avatar>) {
  const initials = name
    ? name
        .toUpperCase()
        .split(" ")
        .map((word) => word[0])
        .slice(0, 2)
        .join("")
    : "";

  const { fallback, base, image } = avatar({ size, square, circle });

  return (
    <div className={base({ className })}>
      {src ? (
        <img src={src} alt={alt} className={image()} />
      ) : (
        <p className={fallback()}>{initials}</p>
      )}
    </div>
  );
}
